import {API_KEY} from './constants';
import type {V2BaseToken} from './types';

export default function getApiKeyFromToken(token: V2BaseToken) {
  return token[API_KEY];
}
